(function (g) {
  const DEBUG = false,
    styles = {
      success: "background: darkgreen; color: white; padding: 2px 6px; border-radius: 3px",
      error: "background: darkred; color: white; padding: 2px 6px; border-radius: 3px",
      warning: "background: darkorange; color: white; padding: 2px 6px; border-radius: 3px",
      info: "background: blue; color: white; padding: 2px 6px; border-radius: 3px"
    };

  function log(...args) { DEBUG && console.log(...args); }
  function collapse(type, data, title = "Log", status = "info") {
    if (!DEBUG) return;
    console.groupCollapsed(`%c ${title}`, styles[status] || styles.info),
      type === "table" ? console.table(data) : console.log(data),
      console.groupEnd();
  }
  log.table = (data, title, status) => collapse("table", data, title, status);
  log.collapse = (data, title, status) => collapse("log", data, title, status);
  g.log = log;
})(typeof window !== "undefined" ? window : globalThis);

/**
 * The function adjusts the Slick carousel based on the window width and a specified breakpoint.
 * @param carousel - The `carousel` parameter is the selector of the elements wrapper
 * @param options - Slick carousel options
 * @param [breakpoint=800] - The `breakpoint` determines at what viewport width the carousel will be destroyed
 */
function handleSlickForMobile(carousel, options, breakpoint = 800) {
  // log.table(options, carousel, "warning");
  var width = $(window).width();
  if (width >= breakpoint && carousel.hasClass('slick-slider')) {
    carousel.slick('unslick');
  } else if (width < breakpoint && !carousel.hasClass('slick-slider')) {
    carousel.slick(options);
  }
}

// Function to copy text to clipboard
function copyToClipboard(text) {
  var $tempInput = $("<input>");
  $("body").append($tempInput);
  $tempInput.val(text).select();
  document.execCommand("copy");
  $tempInput.remove();
}

// // Announcement Timer
function AnnouncementTimer() {
  const timerWrap = $('.announcement__timer');
  if (!timerWrap.length) return;

  const timer = timerWrap.find('.timer');
  let time;

  const timerDate = timerWrap.data('timer-date');
  if (timerDate) {
    const targetTime = new Date(timerDate + "T00:00:00"); // Local midnight of the given date
    time = Math.floor((targetTime - new Date()) / 1000); // Time difference in seconds
  } else {
    time = parseInt(timerWrap.data('time'), 10);
  }

  if (time <= 0) return timerWrap.hide(); // Ensures valid countdown

  const update = () => {
    if (time < 0) return timerWrap.hide();
    timer.text([Math.floor(time / 3600), Math.floor((time % 3600) / 60), time % 60]
      .map(v => v.toString().padStart(2, '0')).join(':'));
    time--;
  };

  update();
  setInterval(update, 1000);
}



$(document).ready(function () {

  $('.video-reviews__wrapper').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '24px',
    arrows: true,
    dots: true,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_205.png?v=1730976741'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_55.png?v=1730976741'/></button>",
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  // Product Gallery Carousel
  $('.bdp_gallery_main').slick({
    dots: false,
    arrows: true,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_205.png?v=1730976741'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_55.png?v=1730976741'/></button>",
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.bdp_gallery_thumb',
    cssEase: 'linear'
  });
  $('.bdp_gallery_thumb').slick({
    dots: false,
    arrows: false,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Group_11.png?v=1724852466'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Group_12.png?v=1724852466'/></button>",
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.bdp_gallery_main',
    cssEase: 'linear',
    focusOnSelect: true
  });


  const Example = $('.example-section');
  const ExampleOptions = {
    infinite: true,
    dots: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  handleSlickForMobile(Example, ExampleOptions, 1024);
  $(window).resize(function () {
    handleSlickForMobile(Example, ExampleOptions, 1024);
  });


  // Video reviews --------------------------------------------------------
  $('.video-reviews__play-button, .video-reviews__video').click(function () {
    const $videoWrapper = $(this).is('.video-reviews__video') ? $(this) : $(this).closest('.video-reviews__video');
    const $video = $videoWrapper.find('video');

    if ($video.length) {
      $('.video-reviews__video').each(function () {
        const $otherWrapper = $(this);
        const $otherVideo = $otherWrapper.find('video');
        if ($otherVideo.get(0) !== $video.get(0)) {
          $otherVideo.removeAttr('controls').prop('muted', true).get(0).pause();
          $otherWrapper.removeClass('play').find('.video-reviews__play-button').show();
        }
      });

      $video.attr('controls', true).prop('muted', false).get(0).play();
      $(this).is($videoWrapper) ? $videoWrapper.find('.video-reviews__play-button').hide() : $(this).hide();
      $videoWrapper.addClass('play');
    }
  });

  // Ingredients --------------------------------------------------------
  $('.ingredients__popup-btn').click(function () {
    show_ingre_popup();
  });
  $('.ingredients__modal-overlay').click(function () {
    hide_ingre_popup();
  });
  function show_ingre_popup() {
    $('.ingredients__modal-overlay').fadeIn(400);
    $('.ingredients__modal').fadeIn(300);
  }
  function hide_ingre_popup() {
    $('.ingredients__modal-overlay').fadeOut(400);
    $('.ingredients__modal').fadeOut(300);
  }


  // Product Slick (Related Products / Product Showcase)
  const productSlickOptions = {
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0596/8419/2545/files/Arrow_Left.png?v=1738610042'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0596/8419/2545/files/Arrow_Right.png?v=1738610042'/></button>",
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }, {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  $('.rl-products__products').slick(productSlickOptions);
  const prShowcaseOptions = $.extend(true, {}, productSlickOptions);
  prShowcaseOptions.responsive = prShowcaseOptions.responsive.map(setting => {
    if (setting.breakpoint > 768) return setting;
    return { ...setting, settings: { ...setting.settings, arrows: true } };
  });
  $('.pr-showcase__products').slick(prShowcaseOptions);


  // Related Products / Product Showcase ATC
  $('.rl-products__atc, .pr-showcase__atc').on('click', function () {
    $.post('/cart/add.js', {
      id: $(this).data('id'),
      quantity: 1
    })
      .done(function (data) {
        window.location.href = '/checkout';
      })
      .fail(function (err) {
        log.collapse(err, 'Error adding to cart', 'error');
      });
  });


  // Initialize section code
  if ($('.announcement__timer').length > 0) {
    AnnouncementTimer();
    $('.announcement__text a').on('click', function (e) {
      e.preventDefault();
      var text = $(this).text().trim();
      copyToClipboard(text);
      log.collapse(text, 'Copied to clipboard', 'success');
    });
  }



  $('.ScrollToProduct').on('click', function (e) {
    e.preventDefault();
    const offsetTop = $('#product-main').offset().top - 90;
    $('html, body').animate({
      scrollTop: offsetTop
    }, 500);
  });

  $(".accordion > .accordion-item").children(".accordion-panel").slideUp();
  $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
  $(".accordion > .accordion-item").click(function () {
    $(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
    $(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
  });
});